import { setFilesUrl } from "../lib/pictures"

// Shops' pictures load from Johku's files: NUXT_PUBLIC_JOHKU_FILES_URL (the CDN by default)
export default defineNuxtPlugin(() => {
  setFilesUrl(String(useRuntimeConfig().public.johkuFilesUrl || ""))
})
